import { jsxs, jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownSlot } from '../slot/Slot.mjs';
import { dropdownItemTitle, dropdownItemTitleText } from './itemTitle.vanilla.mjs';

const DropdownItemTitle = forwardRef(
  ({ children, className: classNameFromProps, rightSlot, ...props }, forwardedRef) => {
    const className = classNames(dropdownItemTitle, classNameFromProps);
    return /* @__PURE__ */ jsxs(
      Primitive.div,
      {
        "data-scope": "dropdown",
        "data-part": "item-title",
        className,
        ref: forwardedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              "data-scope": "dropdown",
              "data-part": "item-title-text",
              className: dropdownItemTitleText,
              children
            }
          ),
          /* @__PURE__ */ jsx(DropdownSlot, { "data-scope": "dropdown", "data-part": "item-title-right-slot", children: rightSlot })
        ]
      }
    );
  }
);

export { DropdownItemTitle };
//# sourceMappingURL=ItemTitle.mjs.map
